import React, { FC, ReactElement } from 'react'
import { Carousel } from 'antd'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import './styles.less'

const ArrowCarousel: FC = ({ children }): ReactElement => (
  <Carousel
    className='arrow-carousel'
    autoplay
    arrows
    dots={false}
    prevArrow={<ArrowLeftOutlined />}
    nextArrow={<ArrowRightOutlined />}>
    {children}
  </Carousel>
)

export { ArrowCarousel }
